<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      title="鹅舍详情"
      detail-form
      id-key="HouseId"
      :data="data"
      form-label-width="85px"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="鹅舍编号">
              <span>{{data.HouseNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="鹅舍类型">
              <span>{{data.HouseType}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="饲养品种">
              <span>{{data.Breed}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="饲养数量">
              <span>{{data.Number}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="温度要求">
              <span>{{data.Temperature}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="湿度要求">
              <span>{{data.Humidity}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="管理人员">
              <span>{{data.EmpName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="环境描述">
              <span>{{data.Description}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="配套设备">
              <span>{{data.Device}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        HouseId: 0,
        HouseNo: "",
        HouseType: null,
        Number: null,
        EmpId: null,
        EmpName: "",
        Breed: "",
        Temperature: "", //温度要求
        Humidity: "", //湿度要求
        Device: "",
        Description: "",
      },
    };
  },
  computed: {},
  methods: {},
};
</script>